define('sortable/sortable',[
  'marionette',
  'underscore',
  'backbone',
  'interact'
], function(
  Mn,
  _,
  Backbone,
  interact
) {

  function Sortable(view, options) {
    
    if (!(view instanceof Mn.CollectionView)) {
      throw new Error('The view must be an instance of Marionette.CollectionView');
    }

    this.options = _.extend({
      isDraggable: function() { return true; },
      isDragHandle: function() { return true; },
      isDroppable: function() { return true; },
      manualStart: false,
      autoScroll: true,
      overlap: 'pointer',
      container: 'body'
    }, options);

    this.view = view;

    this.dragX = 0;
    this.dragY = 0;

    this.droppables = [];

    view.children.each(this.onViewAddChild, this);
    view.on('add:child', this.onViewAddChild, this);
    view.on('remove:child', this.onViewRemoveChild, this);
  };

  _.extend(Sortable.prototype, Backbone.Events, {

    updateModelInCollection: function(model, index, collection) {
      collection.remove(model);
      collection.add(model, { at: index });
    },

    onViewAddChild: function(child) {
      if (this.options.isDraggable(child, child.model)) {
        this.initializeDraggable(child);
      }
    },

    onViewRemoveChild: function(child) {
      if (child.draggable) {
        child.draggable.unset();
      }
    },

    startInteraction: function(e, view) {
      var interaction = e.interaction;
      interaction.start({ name: 'drag' }, e.interactable, e.currentTarget);
    },

    startInteractionByEvent: function(e, view) {
      var interaction = e.interaction;

      if (interaction.interacting() // must not already be interacting
        || (typeof e.button !== 'undefined' && e.button !== 0) // disable right click
      ) {
        return;
      }

      if (!this.options.isDragHandle(e.target, view, view.model, e)){
        return;
      }

      this.startInteraction(e, view);
    },

    initializeDroppables: function() {
      var dragView = this.dragView
          views    = [];

      this.view.children.each(function(view) {
        if (view !== dragView && this.options.isDroppable(view, dragView, dragView.draggable)) {
          this.initializeDroppable(view);
        }
      }, this);
    },

    initializeDroppable: function(view) {
      var self = this;
      var droppable = interact(view.el)
          .dropzone({
            overlap: this.options.overlap,
            ondragenter: function() {

            },
            ondragleave: function() {
              if (self.dragDirectionY === 'up') {
                self.moveUp(self.placeholder);
              } else {
                self.moveDown(self.placeholder);
              }
            }
          });

      this.droppables.push(droppable);
    },

    disableDroppables: function() {
      while (this.droppables.length > 0) {
        this.droppables.pop().dropzone(false);
      }
    },

    initializeDraggable: function(view) {
      var self = this;

      var draggable = interact(view.el)
        .draggable({
          manualStart: this.options.manualStart,
          autoScroll: this.options.autoScroll,
          restriction: document.body
        })
        .on('hold', function(e) {
          // require tablets to use tab hold to begin interaction
          // if (!interact.supportsTouch()) {
          //   return;
          // }
          if (self.options.manualStart) {
            self.startInteractionByEvent(e, view);
          }
        })
        // .on('down', function(e) {
        //   return;
        //   if (interact.supportsTouch()) {
        //     return;
        //   }
        //   self.startInteractionByEvent(e, view);
        // })
        .on('dragstart', function(e) {
          e.preventDefault();
          e.stopPropagation();
          // cache the drag view
          self.dragView = view;
          // setup all the places that can inserted before/after
          self.initializeDroppables();
          // create a placeholder to fill the spot of the drag item
          self.createPlaceholder(view, draggable);
          // apply positioning to the drag view before it is extracted
          self.positionDragView(view, draggable.getRect(), draggable);
          // extract the view to the drag container
          self.extractDragViewToContainer(view, draggable);
          self.dragDx = 0;
          self.dragDy = 0;
          self.indexDiff = 0;
          self.trigger('placeholder:index', self.placeholder, self.currentPlaceholderIndex());
          self.updateDragPosition()
        })
        .on('dragmove', function(e) {
          self.dragDx += e.dx;
          self.dragDy += e.dy;
          self.updateDragPosition();
          if (e.dy > 0) {
            self.dragDirectionY = 'down';
          } else {
            self.dragDirectionY = 'up';
          }
        })
        .on('dragend', function(e) {
          interact.dynamicDrop(false);
          self.clearDragPosition();
          // remove all the positioning information
          self.restoreDragViewToPlaceholder(view, self.placeholder, draggable);
          self.removeDragViewPosition(view, draggable);
          // restore to the drag view
          self.disableDroppables();
          var placeholderIndex = self.currentPlaceholderIndex();
          self.dragView = null;
          self.trigger('placeholder:index', self.placeholder, -1);
          self.destroyPlaceholder();
          if (self.indexDiff != 0) {
            self.updateModelInCollection(view.model, placeholderIndex, self.view.collection);
            self.indexDiff = 0;
          }
          self.trigger('drag:end', self.dragView);

        })

      view.draggable = draggable;
    },

    currentPlaceholderIndex: function() {
      var collection = this.view.collection,
          view       = this.dragView;

      if (!view) {
        return -1;
      }
      return collection.indexOf(view.model) + this.indexDiff
    },

    extractDragViewToContainer: function(view, draggable) {
      view.$el.appendTo(this.options.container);
    },

    positionDragView: function(view, rect, draggable) {
      view.$el
        .css({
          position: 'absolute',
          top: rect.top + 'px',
          left: rect.left + 'px',
          width: rect.width + 'px',
          height: rect.height + 'px'
        })
    },

    removeDragViewPosition: function(view, draggable) {
      view.$el
        .css({
          position: '',
          top: '',
          left: '',
          width: '',
          height: ''
        });
    },

    restoreDragViewToPlaceholder: function(view, placeholder, draggable) {
      view.$el
        .insertAfter(placeholder);
    },

    createPlaceholder: function(view, draggable) {
      var placeholder = $('<div/>'),
          rect        = draggable.getRect();

      this.destroyPlaceholder();
      this.applyDimensionsToPlaceholder(placeholder, draggable.getRect(), view, draggable);
      this.placeholder = placeholder
      view.$el.after(placeholder);
    },

    applyDimensionsToPlaceholder: function(placeholder, rect, view, draggable) {
      placeholder
          .css('width', rect.width + 'px')
          .css('height', rect.height +'px')
    },

    destroyPlaceholder: function() {
      if (this.placeholder) {
        this.placeholder.remove();
      }
      this.placeholder = null;
    },

    clearDragPosition: function() {
      if (this.dragView) {
        this.dragView.$el
            .css('webkitTransform', '')
            .css('transform', '')
            .css('z-index', '')
      }
    },

    updateDragPosition: function() {
      if (this.dragView) {
        var position = 'translate3D(' + this.dragDx + 'px, ' + this.dragDy + 'px, 0px)';
        this.dragView.$el
            .css('webkitTransform', position)
            .css('transform', position)
            .css('z-index', 100);
      }
    },

    moveUp: function(placeholder) {
      var prev = placeholder.prev();
      if (prev.length > 0) {
        prev.before(placeholder);
        this.indexDiff--;
        this.trigger('placeholder:index', this.placeholder, this.currentPlaceholderIndex());
      }
    },

    moveDown: function(placeholder) {
      var next = placeholder.next();
      if (next.length > 0) {
        next.after(placeholder);
        this.indexDiff++;
        this.trigger('placeholder:index', this.placeholder, this.currentPlaceholderIndex());
      }
    }

  });

  Sortable.extend = Backbone.Model.extend;
  return Sortable;
});
